import { ONBOARDING_LAUNCH_DATE } from './Onboarding.types';

export const isEligibleForOnboarding = (
  publishedAt: Date | string | null,
): boolean => {
  if (!publishedAt) return true;

  const publishedDate =
    typeof publishedAt === 'string' ? new Date(publishedAt) : publishedAt;

  return publishedDate >= ONBOARDING_LAUNCH_DATE;
};
